/**
 * Conversation starters configured per embed key (branding.suggested_prompts). Shown on the
 * empty state and again once a turn lands, so a visitor who does not know what to ask always
 * has a way in.
 *
 * Real <button> elements rather than a display chip: these are activated by keyboard, need a
 * focus ring, and must go disabled while a turn is in flight.
 */
export default function SuggestedPrompts({ prompts, onPick, disabled }) {
  if (!prompts?.length) return null;
  return (
    <div className="px-3 pb-2 flex flex-wrap gap-1.5">
      {prompts.map((prompt) => (
        <button
          key={prompt}
          type="button"
          disabled={disabled}
          onClick={() => onPick(prompt)}
          className="text-xs px-3 py-1.5 rounded-full border border-[var(--app-border)]
            bg-[var(--app-surface)] text-secondary-600 transition-colors
            hover:border-primary-400 hover:text-primary-600
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500
            disabled:opacity-50 disabled:pointer-events-none"
        >
          {prompt}
        </button>
      ))}
    </div>
  );
}
